import React, { useEffect, useState } from 'react'
import SuccessStory from '../../CertificateVerification/SuccessStory'
import PlacementSuccessStory from '../../../components/PlacementSuccessStory'
import Faq from '../../CertificateVerification/Faq'
import NewRecognisedSection from '../../../components/NewRecognisedSection'
import ChooseNextCourse from './ChooseNextCourse'
import LcpJob from './LcpJob'
import ChooseNextJob from './ChooseNextJob'
import { useSelector } from 'react-redux'
import { capitalizeWords } from '../../../utils/subscription'
import NinjaBotFeature from '../NinjaBotFeature'
import CourseAccessFeature from '../CourseAccessFeature'
import CertificateUnlockFeature from '../CertificateUnlockFeature'
import CareerGuidanceFeature from '../CareerGuidanceFeature'
import WeekModal from '../WeekModal'
import PlacementModal from '../PlacementModal'
import SkillDevelopmentFeature from '../SkillDevelopmentFeature'
import ProjectShowcaseFeature from '../ProjectShowcaseFeature'
import { Mixpanel } from '../../../config/Mixpanel'
import Constants from '../../../common/constants'
import OnBoardingFaq from '../onBoardingFaq'


const weekModalInfo = [
    {
      id: 1,
      title: "Week 1",
      description: "Building The Ultimate Profile",
      points: [
        "A professionally revamped CV tailored for leadership roles",
        "A high-converting LinkedIn profile that attracts recruiters",
        "A compelling 60-second elevator pitch to introduce yourself confidently",
      ],
      video_link: "https://youtu.be/OKVe7qahDoc",
      thumbnail:
        "https://assets.learntube.ai/files/Optimized_folder/premium/placementImages/week-1.jpg?updatedAt=1688366093369",
    },
    {
      id: 2,
      title: "Week 2",
      description: "Creating Your Job Hunt Plan",
      points: [
        "A step-by-step job hunt strategy designed to get you shortlisted faster",
        "A plan to leverage referrals, direct outreach, and job boards smartly",
        "Insider tactics on what recruiters look for and how to stand out",
        "Guidance on how to apply like a top 1% candidate",
      ],
      video_link: "https://youtu.be/93Y-_Pzk7SM",
      thumbnail:
        "https://assets.learntube.ai/files/Optimized_folder/premium/placementImages/week-2.jpg?updatedAt=1688366094136",
    },
    {
      id: 3,
      title: "Week 3",
      description: "Mastering The Elevator Pitch",
      points: [
        "Training on interview communication, confidence, and body language",
        "Techniques to handle difficult questions and show leadership under pressure",
        "Help to fix grammar errors, MTI, and voice clarity for better spoken English",
        "Voice modulation tools to sound more confident and credible",
      ],
      video_link: "https://youtu.be/Oa73QfUg9WI",
      thumbnail:
        "https://assets.learntube.ai/files/Optimized_folder/premium/placementImages/week-3.jpg?updatedAt=1688366094579",
    },
    {
      id: 4,
      title: "Week 4",
      description: "Live Interview Training",
      points: [
        "Live mock interviews with personalised feedback",
        "Tools to speak with strategic clarity in interviews",
        "Help to become Interview-ready with performance improvement plan",
        "Training on how to lead with vision like top professionals do",
      ],
      video_link: "https://youtu.be/AKUVJT7UYl0",
      thumbnail:
        "https://assets.learntube.ai/files/Optimized_folder/premium/placementImages/week-4.jpg?updatedAt=1688366094496",
    },
  ];

  
const Job = ({razorpayMainHandler , handleOnboardingCompletion}) => {
    const [swiperInstance, setSwiperInstance] = useState(null)
    const firstName = useSelector((store) => store?.profileDetails?.first_name) || "";
    const goal = useSelector((store) => store?.onBoarding?.goal) || "";

    const [youtubeModal, setYoutubeModal] = useState({
        is_open: false,
        info: {},
      });
    const [showModal, setShowModal] = useState(false)

    useEffect(() => {
        Mixpanel.track(Constants.Mixpanel.ONBOARDING_PAGE_25_JOB_PAGE_LOADED);
    }, []);
    
  return (
    <div className='w-full'>
        <div className='font-semibold leading-[130%] text-[28px] text-center text-[#DED996] tracking-[-0.1]'>{firstName}, Land Your Next Job As A {capitalizeWords(goal)} with 100% personalised Job prep. Support</div>
        <div className='mt-8'>
            <LcpJob razorpayMainHandler={razorpayMainHandler} handleOnboardingCompletion={handleOnboardingCompletion}/>
        </div>
        <div className='mt-12 text-center'>
            <div className='text-[16px]  text-white/50'>What Your Career Could Look Like</div>
            <div className='text-[24px] font-semibold text-white leading-[130%]'>In Just 8 Weeks, {firstName}!</div>
            <img alt="" className='w-full mt-4' src="https://storage.googleapis.com/learntube-web-assets/files/OnBoardingPage/Frame%20427322063%20(2).webp"/>
        </div>
        <div className='mt-10'>
            <NewRecognisedSection swiperInstance={swiperInstance} setSwiperInstance={setSwiperInstance}/>
        </div>
        <div className='mt-12 text-center'>
            <div className='text-[16px]  text-white/50'>What You’ll Get</div>
            <div className='text-[24px] font-semibold text-white leading-[130%]'>Everything To Get Placed As A {capitalizeWords(goal)}</div>
            <div className='mt-4 space w-full flex flex-col items-center justify-center gap-2 md:gap-4'>
                <CertificateUnlockFeature/>
                <CareerGuidanceFeature weekModalInfo={weekModalInfo} setYoutubeModal={setYoutubeModal} setShowModal={setShowModal}/>
                <SkillDevelopmentFeature/>
                <ProjectShowcaseFeature/>
                <CourseAccessFeature/>
                <NinjaBotFeature/>
            </div>
            <div className='w-full text-center font-semibold text-[#70AEFF] text-[14px] mt-4'>& Many More...</div>

        </div>
        <div className='mt-12'>
            <ChooseNextJob razorpayMainHandler={razorpayMainHandler} handleOnboardingCompletion={handleOnboardingCompletion}/>
        </div>
        <div className='mt-12 w-full flex flex-col items-center justify-center text-center'>
            <div className='text-[16px]  text-white/50'>Success Stories</div>
            <div className='text-[24px] font-semibold text-white mb-4 leading-[130%]'>Real Learners, Real Outcomes</div>
            <PlacementSuccessStory/>
        </div>
        <div className='mt-12'>
            <SuccessStory/>
        </div>
        <div className="mt-12 mb-4 text-center text-[24px] font-semibold text-white">
          Frequently{" "}
          <span className=""> Asked </span>{" "}
          Questions
        </div>
       <OnBoardingFaq/>
       {youtubeModal?.is_open && youtubeModal?.info?.id && (
        <WeekModal openModal={youtubeModal} setOpenModal={setYoutubeModal} />
      )}
        {showModal && (
        <PlacementModal
          isOpen={showModal}
          setIsOpen={setShowModal}
          showButton={true}
        />
      )}
    </div>
  )
}

export default Job